const MuiTextField = {
  styleOverrides: {
    root: {
      borderRadius: 8,
      border: "1px solid $faded-grey",
      marginBottom: 24,
    },
  },
};

export default MuiTextField;
